const RESET = 'RESET';

export {
	RESET
};
